(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-accordion"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('image-accordion')) {

  customElements.define('image-accordion', class extends HTMLElement {

    connectedCallback() {

      this.abort?.abort();

      this.abort = new AbortController();

      const options = { signal: this.abort.signal };

      this.panels = Array.from(this.querySelectorAll('.ia-panel'));

      this.panels.forEach((panel, index) => {

        panel.addEventListener('pointerenter', event => {

          if (event.pointerType === 'mouse') this.open(index);

        }, options);

        panel.querySelector('.ia-toggle').addEventListener('click', () => this.open(index), options);

        panel.addEventListener('focusin', () => this.open(index), options);

        panel.querySelector('.ia-toggle').addEventListener('keydown', event => {

          let next;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.panels.length;

          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + this.panels.length) % this.panels.length;

          if (event.key === 'Home') next = 0;

          if (event.key === 'End') next = this.panels.length - 1;

          if (next !== undefined) {

            event.preventDefault();

            this.open(next);

            this.panels[next].querySelector('.ia-toggle').focus();

          }

        }, options);

      });

      this.addEventListener('pointerleave', event => {

        if (event.pointerType === 'mouse' && this.dataset.reset === 'true' && !this.contains(document.activeElement)) this.open(0);

      }, options);

      this.addEventListener('shopify:block:select', event => {

        const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);

        if (index >= 0) this.open(index);

      }, options);

      this.open(0);

      const track = this.querySelector('.ia-track');

      this.resize = new ResizeObserver(() => {

        if (this.dataset.layout !== 'square') return;

        const style = getComputedStyle(this);

        const ratio = parseFloat(style.getPropertyValue('--ia-open'));

        const gap = parseFloat(style.getPropertyValue('--ia-gap'));

        const height = (track.clientWidth - gap * (this.panels.length - 1)) * ratio / (ratio + this.panels.length - 1);

        this.style.setProperty('--ia-square-height', Math.max(0, height) + 'px');

      });

      this.resize.observe(track);

    }

    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }

    open(index) {

      this.panels.forEach((panel, current) => {

        const active = current === index;

        panel.classList.toggle('is-active', active);

        panel.querySelector('.ia-toggle').setAttribute('aria-expanded', String(active));

        const content = panel.querySelector('.ia-content');

        content.inert = !active;

        content.setAttribute('aria-hidden', String(!active));

      });

    }

  });

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ww-content-tabs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ww-content-tabs')) {
 customElements.define('ww-content-tabs',class extends HTMLElement {
  connectedCallback(){
   this.abort?.abort();
   this.abort=new AbortController();
   const opt={signal:this.abort.signal};
   const container=this.querySelector('.wt-panels');
   this.panels=Array.from(container.querySelectorAll('.wt-panel')).filter(panel=>panel.closest('ww-content-tabs')===this);
   this.nav=this.querySelector('.wt-nav');
   this.nav.replaceChildren();
   this.buttons=this.panels.map((panel,index)=>{
    const button=document.createElement('button');
    button.type='button';button.className='wt-tab';button.setAttribute('role','tab');
    button.id=this.id+'-tab-'+index;
    panel.id=this.id+'-panel-'+index;
    button.textContent=panel.dataset.title||'Tab '+(index+1);
    button.setAttribute('aria-controls',panel.id);
    panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',button.id);panel.tabIndex=0;
    button.addEventListener('click',()=>this.activate(index),opt);
    button.addEventListener('pointerenter',event=>{
     if(this.dataset.hover==='true'&&event.pointerType==='mouse'&&!this.contains(document.activeElement))this.activate(index);
    },opt);
    button.addEventListener('keydown',event=>{
     let next;
     const rtl=getComputedStyle(this).direction==='rtl';
     if(event.key==='ArrowRight')next=(index+(rtl?-1:1)+this.buttons.length)%this.buttons.length;
     if(event.key==='ArrowLeft')next=(index+(rtl?1:-1)+this.buttons.length)%this.buttons.length;
     if(event.key==='Home')next=0;
     if(event.key==='End')next=this.buttons.length-1;
     if(next!==undefined){event.preventDefault();this.activate(next);this.buttons[next].focus();}
    },opt);
    this.nav.append(button);return button;
   });
   this.nav.hidden=this.buttons.length===0;
   this.setAttribute('data-ready','');
   this.activate(Math.min(Math.max((Number(this.dataset.default)||1)-1,0),this.panels.length-1));
   this.addEventListener('shopify:block:select',event=>{
    const panel=event.target.closest('.wt-panel');
    const index=this.panels.indexOf(panel);
    if(index>=0)this.activate(index);
   },opt);
  }
  disconnectedCallback(){this.abort?.abort();}
  activate(index){
   this.panels.forEach((panel,i)=>{
    const active=i===index;const changed=panel.hidden===active;
    panel.hidden=!active;panel.inert=!active;
    this.buttons[i].setAttribute('aria-selected',String(active));this.buttons[i].tabIndex=active?0:-1;
    if(active&&changed){requestAnimationFrame(()=>{if(this.isConnected){window.dispatchEvent(new Event('resize'));panel.dispatchEvent(new CustomEvent('ww:tab:shown',{bubbles:true,detail:{panelId:panel.id,index:i}}));}});}
   });
  }
 });
}

  } catch(e) { console.error(e); }
})();
})();
